import client from '../../providers/fetchClient'

export const getHistoricalData = id => client.get(`/v3/lead-updates?lead_id=${id}`)

export const createLeadUpdate = data => client.post('/v3/lead-updates', data)

export const deleteLeadUpdate = id => client.delete(`/v3/lead-updates/${id}`)
